module.exports = __webpack_public_path__ + "media/images/like_this_cmnd_front_old-966abd4cc57fb33d2e68b1505f7b3355.jpg";